module.exports = __webpack_public_path__ + "img/FR30478.12b7887d.png";